export const selectCapitalBalance = state => state.capitalBalance;

// FISCAL
export const selectFiscalCapitalBalance = state =>
  selectCapitalBalance(state).fiscal;

export const selectFiscalCapitalBalanceList = state =>
  selectFiscalCapitalBalance(state).items;

export const selectFiscalCapitalBalanceListCount = state =>
  selectFiscalCapitalBalance(state).count;

export const selectFiscalCapitalBalanceQueryOptions = state => {
  const { options } = selectFiscalCapitalBalance(state);

  const cleanedOptions = { ...options };
  Object.keys(cleanedOptions).forEach(key => {
    if (cleanedOptions[key] === '') {
      delete cleanedOptions[key];
    }
  });

  return cleanedOptions;
};

export const selectFiscalCapitalBalanceSummary = state =>
  selectFiscalCapitalBalance(state).summary;

export const selectFiscalCapitalBalanceSummaryList = state =>
  selectFiscalCapitalBalanceSummary(state).items;

export const selectFiscalCapitalBalanceSummaryCount = state =>
  selectFiscalCapitalBalanceSummary(state).count;

export const selectFiscalCapitalBalanceKpis = state =>
  selectFiscalCapitalBalance(state).kpis;

// ACCOUNTING
export const selectAccountingCapitalBalance = state =>
  selectCapitalBalance(state).accounting;

export const selectAccountingCapitalBalanceList = state =>
  selectAccountingCapitalBalance(state).items;

export const selectAccountingCapitalBalanceListCount = state =>
  selectAccountingCapitalBalance(state).count;

export const selectAccountingCapitalBalanceQueryOptions = state => {
  const { options } = selectAccountingCapitalBalance(state);

  const cleanedOptions = { ...options };
  Object.keys(cleanedOptions).forEach(key => {
    if (cleanedOptions[key] === '') {
      delete cleanedOptions[key];
    }
  });
  return cleanedOptions;
};

export const selectAccountingCapitalBalanceSummary = state =>
  selectAccountingCapitalBalance(state).summary;

export const selectAccountingCapitalBalanceSummaryList = state =>
  selectAccountingCapitalBalanceSummary(state).items;

export const selectAccountingCapitalBalanceSummaryCount = state =>
  selectAccountingCapitalBalanceSummary(state).count;

export const selectAccountingCapitalBalanceKpis = state =>
  selectAccountingCapitalBalance(state).kpis;
